<h1 mat-dialog-title>Contact Us</h1>
<div mat-dialog-content>
  <form>
    <div class="form-group row">
      <div class="col-sm-3">
        Email
      </div>
      <div class="col-sm-9">
        <a class="footer-nav-link" href="mailto:BIDIT-Support@IDIMN.COM">BIDIT-Support&#64;IDIMN.COM</a>
      </div>
    </div>
    <div class="row">
      <button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel">OK</button>
    </div>
  </form>
</div>

